module.exports = __webpack_public_path__ + "img/_vfy_logo.5d352cf8.svg";